import { mapState } from 'vuex'

export default {
  created() {
    const t = this.pageTitleMixinNeedTitle
    const nt = this.$t(t)
    if (nt) {
      document.title = nt
    }
  },
  computed: {
    ...mapState('redraw', ['lang']),
  },
  watch: {
    lang(nv, ov) {
      const nt = this.$t(this.pageTitleMixinNeedTitle)
      if (nt) {
        document.title = nt
      }
    }
  }
}
